import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaBuilding,
  FaUsers,
  FaUserCircle,
  FaBoxOpen,
  FaWarehouse,
  FaMapMarkerAlt,
  FaStore,
  FaBalanceScale,
  FaTags,
  FaShoppingCart,
  FaTruckLoading,
  FaTruckMoving,
  FaExchangeAlt,
  FaBoxes,
  FaClipboardList,
  FaCog,
  FaChevronDown,
  FaChevronRight,
  FaChartBar,
  FaHistory,
  FaThLarge,          // untuk Zone (ganti dari FaWarehouse)
  FaTag,              // untuk Category (ganti dari FaTags)
  FaClipboard,        // untuk Picking Outstanding (ganti dari FaClipboardList)
  FaRegClock,         // untuk Putaway History (ganti dari FaHistory)
  FaClipboardCheck,
} from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";

const Sidebar = () => {
  const location = useLocation();
  const [masterOpen, setMasterOpen] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const [salesOpen, setSalesOpen] = useState(false);
  const [inboundOpen, setInboundOpen] = useState(false);
  const [outboundOpen, setOutboundOpen] = useState(false);
  const [shippingOpen, setShippingOpen] = useState(false);
  const [stockOpen, setStockOpen] = useState(false);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  
  const [role, setRole] = useState("Operator");
  const { user } = useAuth();

  useEffect(() => {
    const currentRole = user?.role || "Operator";
    setRole(currentRole);
  }, [user]);

  const toggleMaster = () => setMasterOpen(!masterOpen);
  const toggleSetting = () => setSettingOpen(!settingOpen);
  const toggleSales = () => setSalesOpen(!salesOpen);
  const toggleInbound = () => setInboundOpen(!inboundOpen);
  const toggleOutbound = () => setOutboundOpen(!outboundOpen);
  const toggleShipping = () => setShippingOpen(!shippingOpen);
  const toggleStock = () => setStockOpen(!stockOpen);
  const toggleDashboard = () => setDashboardOpen(!dashboardOpen);

  const menuItems = [
    { label: "Client", icon: <FaBuilding />, path: "/tenant", roles: ["Superadmin"] },
    { label: "User", icon: <FaUsers />, path: "/user", roles: ["Superadmin"] },
    // Inbound group (moved to separate array below)
    
    //{ label: "Outbound Order", icon: <FaTruckMoving />, path: "/outbound-orders", roles: ["Admin", "Operator", "Superadmin"] },
    //{ label: "Picking Outstanding", icon: <FaClipboardList />, path: "/picking-outstanding", roles: ["Operator", "Admin", "Superadmin"] },
    //{ label: "Picking History", icon: <FaHistory />, path: "/picking-history", roles: ["Operator", "Admin", "Superadmin"] },
    //{ label: "Stock Opname", icon: <FaClipboardList />, path: "/stock-opnames", roles: ["Admin", "Superadmin"] },
    
  ];

  const masterItems = [
	  { label: "Customer", icon: <FaUserCircle />, path: "/customer", roles: ["Admin_Sales", "Sales", "Admin", "Superadmin"] },
	  { label: "Vendor", icon: <FaStore />, path: "/vendors", roles: ["Admin", "Superadmin"] },
	  { label: "Product", icon: <FaBoxOpen />, path: "/products", roles: ["Admin_Sales", "Admin", "Superadmin"] },
	  { label: "Products Price", icon: <FaTags />, path: "/products-price", roles: ["Admin_Sales", "Superadmin"] },
	];

  const salesItems = [
	  { label: "Sales Order", icon: <FaShoppingCart />, path: "/sales-orders", roles: ["Admin_Sales", "Sales", "Superadmin"] },
	];
	
  const inboundItems = [
    { label: "Inbound Order", icon: <FaTruckLoading />, path: "/inbound-orders", roles: ["Operator", "Admin", "Superadmin"] },
    { label: "Putaway Outstanding", icon: <FaClipboardCheck />, path: "/putaway-outstanding", roles: ["Operator", "Admin", "Superadmin"] },
    { label: "Putaway History", icon: <FaRegClock />, path: "/putaway-history", roles: ["Operator", "Admin", "Superadmin"] },
  ];
  
  const outboundItems = [
    { label: "Outbound Order", icon: <FaTruckMoving />, path: "/outbound-orders", roles: ["Admin", "Operator", "Superadmin"] },
    { label: "Picking Outstanding", icon: <FaClipboard />, path: "/picking-outstanding", roles: ["Operator", "Admin", "Superadmin"] },
    { label: "Picking History", icon: <FaHistory />, path: "/picking-history", roles: ["Operator", "Admin", "Superadmin"] },
  ];
  
  const shippingItems = [
    { label: "Shipping Order", icon: <FaTruckMoving />, path: "/shipping-orders", roles: ["Admin", "Superadmin"] },
  ];

  const stockItems = [
    { label: "Stock Location", icon: <FaBoxes />, path: "/stocks", roles: ["Admin", "Operator", "Superadmin"] },
    { label: "Stock Movement", icon: <FaExchangeAlt />, path: "/stock-movements", roles: ["Admin", "Operator", "Superadmin"] },
  ];
  
  const dashboardItems = [
	{ label: "Inbound & Outbound", icon: <FaHome />, path: "/dashboard-transaction", roles: ["Admin", "Supervisor", "Superadmin"] },
	{ label: "Inventory", icon: <FaHome />, path: "/dashboard-inventory", roles: ["Admin", "Supervisor", "Superadmin"] },
	{ label: "Sales", icon: <FaChartBar />, path: "/dashboard-sales", roles: ["Admin_Sales", "Sales", "Superadmin"] },
	//{ label: "Productivity", icon: <FaHome />, path: "/dashboard-productivity", roles: ["Admin", "Supervisor", "Superadmin"] },
  ];

  const settingItems = [
    { label: "Warehouse", icon: <FaWarehouse />, path: "/warehouse", roles: ["Admin_Sales", "Admin", "Superadmin"] },
    { label: "Zone", icon: <FaThLarge />, path: "/zone", roles: ["Admin", "Superadmin"] },
    { label: "Location", icon: <FaMapMarkerAlt />, path: "/locations", roles: ["Admin_Sales", "Admin", "Superadmin"] },
    { label: "UOM", icon: <FaBalanceScale />, path: "/uoms", roles: ["Admin_Sales", "Admin", "Superadmin"] },
    { label: "Category", icon: <FaTag />, path: "/categories", roles: ["Admin_Sales", "Admin", "Superadmin"] },
  ];

  const isInsideMaster = masterItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideSetting = settingItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideSales = salesItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideInbound = inboundItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideOutbound = outboundItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideShipping = shippingItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideStock = stockItems.some((item) => location.pathname.startsWith(item.path));
  const isInsideDashboard = dashboardItems.some((item) => location.pathname.startsWith(item.path));
  
  const isMasterOpen = masterOpen || isInsideMaster;
  const isSettingOpen = settingOpen || isInsideSetting;
  const isSalesOpen = salesOpen || isInsideSales;
  const isInboundOpen = inboundOpen || isInsideInbound;
  const isOutboundOpen = outboundOpen || isInsideOutbound;
  const isShippingOpen = shippingOpen || isInsideShipping;
  const isStockOpen = stockOpen;
  const isDashboardOpen = dashboardOpen || isInsideDashboard;
  
  useEffect(() => {
	  if (isInsideMaster) setMasterOpen(true);
	  if (isInsideSales) setSalesOpen(true);
	  if (isInsideInbound) setInboundOpen(true);
	  if (isInsideStock) setStockOpen(true);
	  if (isInsideSetting) setSettingOpen(true);
	  if (isInsideOutbound) setOutboundOpen(true); // Tambahan
	  if (isInsideShipping) setShippingOpen(true); // Tambahan
	  if (isInsideDashboard) setDashboardOpen(true); // Tambahan
	}, [location.pathname]);


  return (
    <div className="w-60 h-screen text-white flex flex-col" style={{ backgroundColor: "#215b67" }}>
      <div className="p-3 text-lg font-bold flex items-center gap-4 bg-white text-black">
        <img src="/logo-stardia-wns.jpg" alt="Stardia WMS" className="h-7" />
      </div>
      <nav className="flex-1 p-2 space-y-0.5" style={{ overflowY: "auto", maxHeight: "calc(100vh - 64px)" }}>
        {/* Filtered Main Menu */}
        {menuItems
          .filter((item) => !item.roles || item.roles.includes(role))
          .map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2 rounded hover:bg-white/20 transition ${
                location.pathname === item.path ? "bg-white/30 font-semibold" : ""
              }`}
            >
              <span className="text-sm">{item.icon}</span>
              <span className="text-sm">{item.label}</span>
            </Link>
          ))}

        {/* Master Group */}
		<div className="mt-2">
		  <button
			onClick={toggleMaster}
			className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
		  >
			<span className="flex items-center gap-2">
			  <FaClipboardList />
			  <span>Master</span>
			</span>
			{isMasterOpen ? <FaChevronDown /> : <FaChevronRight />}
		  </button>

		  {isMasterOpen && (
			<div className="mt-1 space-y-0.5">
			  {masterItems
				.filter((item) => !item.roles || item.roles.includes(role))
				.map((item) => (
				  <Link
					key={item.path}
					to={item.path}
					className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
					  location.pathname === item.path ? "bg-white/30 font-semibold" : ""
					}`}
				  >
					<span className="text-[13px]">{/*item.icon*/}</span>
					<span className="text-[13px]">{item.label}</span>
				  </Link>
				))}
			</div>
		  )}
		</div>
		
		{/* Sales Group */}
		{(role == "Admin_Sales" || role === "Sales") && (
        <div className="mt-2">
          <button
            onClick={toggleSales}
            className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
          >
            <span className="flex items-center gap-2">
              <FaShoppingCart />
              <span>Sales</span>
            </span>
            {isSalesOpen ? <FaChevronDown /> : <FaChevronRight />}
          </button>

          {isSalesOpen && (
            <div className="mt-1 space-y-0.5">
              {salesItems
                .filter((item) => !item.roles || item.roles.includes(role))
                .map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
                      location.pathname === item.path ? "bg-white/30 font-semibold" : ""
                    }`}
                  >
                    <span className="text-[13px]">{/*item.icon*/}</span>
                    <span className="text-[13px]">{item.label}</span>
                  </Link>
                ))}
            </div>
          )}
        </div>
		)}
		
		{/* Inbound Group */}
		{role !== "Admin_Sales" && role !== "Sales" && (
        <div className="mt-2">
          <button
            onClick={toggleInbound}
            className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
          >
            <span className="flex items-center gap-2">
              <FaTruckLoading />
              <span>Inbound</span>
            </span>
            {isInboundOpen ? <FaChevronDown /> : <FaChevronRight />}
          </button>

          {isInboundOpen && (
            <div className="mt-1 space-y-0.5">
              {inboundItems
                .filter((item) => !item.roles || item.roles.includes(role))
                .map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
                      location.pathname === item.path ? "bg-white/30 font-semibold" : ""
                    }`}
                  >
                    <span className="text-[13px]">{/*item.icon*/}</span>
                    <span className="text-[13px]">{item.label}</span>
                  </Link>
                ))}
            </div>
          )}
        </div>
		)}
		
		{/* Outbound Group */}
		{role !== "Admin_Sales" && role !== "Sales" && (
		<div className="mt-2">
		  <button
			onClick={toggleOutbound}
			className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
		  >
			<span className="flex items-center gap-2">
			  <FaTruckMoving />
			  <span>Outbound</span>
			</span>
			{isOutboundOpen ? <FaChevronDown /> : <FaChevronRight />}
		  </button>

		  {isOutboundOpen && (
			<div className="mt-1 space-y-0.5">
			  {outboundItems
				.filter((item) => !item.roles || item.roles.includes(role))
				.map((item) => (
				  <Link
					key={item.path}
					to={item.path}
					className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
					  location.pathname === item.path ? "bg-white/30 font-semibold" : ""
					}`}
				  >
					<span className="text-[13px]">{/*item.icon*/}</span>
					<span className="text-[13px]">{item.label}</span>
				  </Link>
				))}
			</div>
		  )}
		</div>
		)}
		
		{/* Shipping Group }
		{role !== "Admin_Sales" && role !== "Sales" && role !== "Operator" && (
		<div className="mt-2">
		  <button
			onClick={toggleShipping}
			className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
		  >
			<span className="flex items-center gap-2">
			  <FaTruckMoving />
			  <span>Shipping</span>
			</span>
			{isShippingOpen ? <FaChevronDown /> : <FaChevronRight />}
		  </button>

		  {isShippingOpen && (
			<div className="mt-1 space-y-0.5">
			  {shippingItems
				.filter((item) => !item.roles || item.roles.includes(role))
				.map((item) => (
				  <Link
					key={item.path}
					to={item.path}
					className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
					  location.pathname === item.path ? "bg-white/30 font-semibold" : ""
					}`}
				  >
					<span className="text-sm">{item.label}</span>
				  </Link>
				))}
			</div>
		  )}
		</div>
		)}
		*/ } 
		
		{/* Stock Group */}
		{role !== "Admin_Sales" && role !== "Sales" && (
		<div className="mt-2">
		  <button
			onClick={toggleStock}
			className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
		  >
			<span className="flex items-center gap-2">
			  <FaBoxes />
			  <span>Stock</span>
			</span>
			{isStockOpen ? <FaChevronDown /> : <FaChevronRight />}
		  </button>

		  {isStockOpen && (
			<div className="mt-1 space-y-0.5">
			  {stockItems
				.filter((item) => !item.roles || item.roles.includes(role))
				.map((item) => (
				  <Link
					key={item.path}
					to={item.path}
					className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
					  location.pathname === item.path ? "bg-white/30 font-semibold" : ""
					}`}
				  >
					<span className="text-[13px]">{/*item.icon*/}</span>
					<span className="text-[13px]">{item.label}</span>
				  </Link>
				))}
			</div>
		  )}
		</div>
		)}

		{/* Dashboard Group */}
		<div className="mt-2">
		  <button
			onClick={toggleDashboard}
			className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
		  >
			<span className="flex items-center gap-2">
			  <FaChartBar />
			  <span>Dashboard</span>
			</span>
			{isDashboardOpen ? <FaChevronDown /> : <FaChevronRight />}
		  </button>

		  {isDashboardOpen && (
			<div className="mt-1 space-y-0.5">
			  {dashboardItems
				.filter((item) => !item.roles || item.roles.includes(role))
				.map((item) => (
				  <Link
					key={item.path}
					to={item.path}
					className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
					  location.pathname === item.path ? "bg-white/30 font-semibold" : ""
					}`}
				  >
					<span className="text-[13px]">{/*item.icon*/}</span>
					<span className="text-[13px]">{item.label}</span>
				  </Link>
				))}
			</div>
		  )}
		</div>
		
        {/* Expandable Settings */}
		{role !== "Operator" && role !== "Sales" && (
        <div className="mt-4">
          <button
            onClick={toggleSetting}
            className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-white/80 hover:bg-white/10 rounded"
          >
            <span className="flex items-center gap-2">
              <FaCog />
              <span>Setting</span>
            </span>
            {isSettingOpen ? <FaChevronDown /> : <FaChevronRight />}
          </button>

          {isSettingOpen && (
            <div className="mt-1 space-y-0.5">
              {settingItems
                .filter((item) => !item.roles || item.roles.includes(role))
                .map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 px-6 py-2 rounded hover:bg-white/20 transition ${
                      location.pathname === item.path ? "bg-white/30 font-semibold" : ""
                    }`}
                  >
                    <span className="text-[13px]">{/*item.icon*/}</span>
                    <span className="text-[13px]">{item.label}</span>
                  </Link>
                ))}
            </div>
          )}
        </div>
		)}
      </nav>
    </div>
  );
};

export default Sidebar;
